module.exports = __webpack_public_path__ + "img/FaceRetouchingOffOutlined.919bd35e.svg";